import { useEffect, useState, useRef } from "react";
import CommonFilters from "../../components/BreadCrumbs/CommonFilters";
import TabsComponent from "../../components/NewTabs";
import { getDecodeURI, getEncodedURI, updateTimePeriod, checkLoggedInUserAuthorizedToViewPage, readableBytesAsGB, strToK4List, readableBytesAsMB, generateCustomUsageCSV } from "../../utils/util";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../config";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Box, Button, Grid, InputAdornment, TextField } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import './analytics.css';
import { SIDE_MENU_ITEM_ANALYTICS } from "../../utils/constants";
import newDownloadButton from '../../asset/image/NewDownloadButton.svg';
import upArrow from '../../asset/image/newUpArrow.svg';
import downArrow from '../../asset/image/newDownArrow.svg';
import analyticsdata from './analyticsData.json';
import { updatePermission } from "../../actions/Users/authenticate";
import _ from "lodash";
import { getInterval, updateCardContent } from "./utils";
import AnalyticsCardContents from "./AnalyticsCard";
import AnalyticsBarChart from "./BarChart";
import AnalyticsLineChart from "./LineChart";
import AnalyticsFilters from "./Filters";
import AnalyticsTable from "./Table";
import { processAnalyticsLeftChartPayload, processAnalyticsRightChartPayload, processAnalyticsTablePayload, processAnalyticsTopWidgetPayload } from "./service";
import { GET_ANALYTICS_BAR_CHART, GET_ANALYTICS_LINE_CHART, GET_ANALYTICS_TABLE, GET_ANALYTICS_TOP_CARDS } from "../../actions/types";
import NetworkTable from "../InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable";
import SearchBar from "../InventoryPage/InventorySettings/components/SearchBar/SearchBar";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';

const AnalyticsDashboard = (props) => {
    const { authReducer, sideMenu, getVesselsListing, filteredVessels, selectedOu, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, match, location, history, updatePermission, analyticsTopCards, analyticsLeftChart, analyticsRightChart, analyticsTable, setAnalyticsTopCardsLoading, setAnalyticsBarChartLoading, setAnalyticsLineChartLoading, setAnalyticsTableLoading } = props;

    const _q = getDecodeURI(location?.search);
    const [loading, setLoading] = useState();
    const [activeTab, setActiveTab] = useState<string>(match?.params?.tab ? match.params.tab : 'captive');
    const [subTab, setSubTab] = useState(_q.hasOwnProperty('tab') ? _q.tab : '');
    const [filterPopup, setFilterPopup] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [tableSearchValue, setTableSearchValue] = useState('');
    const [isCardExpanded, setIsCardExpanded] = useState(true);
    const [isLeftChartsExpanded, setIsLeftChartsExpanded] = useState(true);
    const [expand, setExpand] = useState({ isCardExpanded: true, isLeftChartsExpanded: true, isTableExpanded: analyticsdata?.[activeTab]?.[subTab]?.hideCharts ? true : false })
    const [vessels, setVessels] = useState<any>([]);
    const [sites, setSites] = useState<any>(_q.hasOwnProperty('k4Ids') && _q.k4Ids != '' ? [...strToK4List(_q.k4Ids)?.map((ele) => { return { id: ele["id"], name: ele['vessel-name'] } })] : []);
    const [analyticsData, setAnalyticsData] = useState(analyticsdata);
    const [leftChartData, setLeftChartData] = useState<any>();
    const [rightChartData, setRightChartData] = useState<any>();
    const [tableData, setTableData] = useState<any>();
    const [chartType, setChartType] = useState('bar');
    const [lineChartType, setLineChartType] = useState('spline')
    const [selectedBin, setSelectedBin] = useState(getInterval(Math.ceil(((new Date(newSummaryEndDate)).getTime() - (new Date(newSummaryStartDate)).getTime()) / 60e3)));
    const DEFAULT_PAGE_SIZE = 15;
    const ASC_ORDER = "asc";
    const DESC_ORDER = "desc";
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(_q.hasOwnProperty('limit') ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
    const [sort, setSort] = useState<any>(_q.hasOwnProperty("sort") ? _q.sort : '');
    const [sortOrder, setSortOrder] = useState<any>(_q.hasOwnProperty("sortOrder") ? _q.sortOrder : DESC_ORDER);
    const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
    const [visibleColumns, setVisibleColumns] = useState<string[]>([]);
    const dispatch = useDispatch();

    const HighchartsInstance = { ...Highcharts };
    Exporting(HighchartsInstance);
    ExportData(HighchartsInstance);
    Highcharts.setOptions({
        exporting: { enabled: false },
    });

    if (authReducer && (!authReducer.sideMenu || SIDE_MENU_ITEM_ANALYTICS !== authReducer.sideMenu.menuItem)) {
        authReducer.sideMenu = { menuItem: SIDE_MENU_ITEM_ANALYTICS };
    }

    const VIEW_VESSEL_SUMMARY = "view-vessel-summary";
    const viewVesselSummaryService = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["service"];
    const viewVesselSummaryFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["function"];

    const downloadCSV = (data, columns, filename = 'table-data.csv') => {
        if (!data || !columns || !data.length) {
            console.error("No data to convert.");
            return;
        }
        const headers = columns.map(col => `"${col.label || col.key}"`).join(",");
        const rows = data.map((row, rowIndex) => {
            const rowStr = columns.map(col => {
                const rawValue = row[col.key];
                const cleaned = rawValue !== undefined && rawValue !== null ? String(rawValue).replace(/"/g, '""') : '';
                return `"${cleaned}"`;
            }).join(",");
            // if (rowIndex < 3) console.log(`Row ${rowIndex + 1} `, rowStr); 
            return rowStr;
        });

        const csvContent = [headers, ...rows].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        let authorized = checkLoggedInUserAuthorizedToViewPage(viewVesselSummaryService, viewVesselSummaryFunction);
        const info = {
            isMultiVessel: false,
            isSingleVessel: false,
            showOu: false,
            ou: selectedOu ? selectedOu : {}
        };

        if (authorized) {
            info.isMultiVessel = true;
            info.showOu = true;
        }
        updatePermission(info);
        const params = getDecodeURI(location?.search);
        const { startDate, endDate } = updateTimePeriod(dispatch, location);
        params.startDate = startDate;
        params.endDate = endDate;
        history.push({ pathname: location.pathname, search: getEncodedURI(params) });
    }, []);

    useEffect(() => {
        if (_.isEmpty(getVesselsListing))
            return;
        let vessels = [];
        const filteredVesselsList = filteredVessels;
        if (filteredVesselsList && filteredVesselsList.length > 0) {
            vessels = filteredVesselsList;
        } else {
            vessels = getVesselsListing?.locations;
        }
        setVessels(vessels);
        setSites([]);
    }, [getVesselsListing, filteredVessels])

    useEffect(() => {
        setExpand({ ...expand, isLeftChartsExpanded: true, isTableExpanded: analyticsdata?.[activeTab]?.[subTab]?.hideCharts ? true : false })
        const selectedTab = analyticsData?.tabs?.[activeTab];
        if (_q.hasOwnProperty('tab') && _q.tab) {
            setSubTab(_q.tab);
        } else if (selectedTab?.subTabs?.length) {
            setSubTab(selectedTab.subTabs[0].tabValue);
        }
    }, [activeTab]);

    useEffect(() => {
        const tableConfigColumns = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys?.columns;
        if (!Array.isArray(tableConfigColumns)) return;

        const activeCols = tableConfigColumns.filter(col => col.status === 'active');

        setVisibleColumns(activeCols.map(col => col.key));
        setSelectedColumns(activeCols.map(col => col.label));
    }, [activeTab, subTab]);


    useEffect(() => {
        setLoading(setAnalyticsTopCardsLoading || setAnalyticsBarChartLoading || setAnalyticsLineChartLoading || setAnalyticsTableLoading)
    }, [setAnalyticsTopCardsLoading, setAnalyticsBarChartLoading, setAnalyticsLineChartLoading, setAnalyticsTableLoading])

    useEffect(() => {
        const tableConfigColumns = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys?.columns;
        if (!Array.isArray(tableConfigColumns)) return;
        setVisibleColumns(prev => {
            if (Array.isArray(prev) && prev.length > 0) return prev;
            return tableConfigColumns
                .filter(col => col.status === 'active')
                .map(col => col.key);
        });
    }, [analyticsData, activeTab, subTab]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            processAnalyticsTablePayload(
                dispatch,
                analyticsData,
                selectedOu,
                vessels,
                sites,
                newSummaryStartDate,
                newSummaryEndDate,
                newSummaryWanType,
                page,
                limit,
                sort,
                sortOrder,
                activeTab,
                subTab,
                tableSearchValue
            );
        }, 400);

        return () => clearTimeout(delayDebounce);
    }, [
        tableSearchValue,
        page,
        limit,
        sort,
        sortOrder,
        activeTab,
        subTab
    ]);

    const doNavigateSIM = (pathname, tabName) => {
        const currentParams = getDecodeURI(location?.search);
        const params: any = {};
        if (currentParams.ouName) {
            params['ouName'] = currentParams.ouName;
        }
        if (currentParams.ouId) {
            params['ouId'] = currentParams.ouId;
        }
        if (currentParams.k4Ids) {
            params['k4Ids'] = currentParams.k4Ids;
        }
        if (currentParams.sideNav) {
            params['sideNav'] = currentParams.sideNav
        }
        if (currentParams.interval) {
            params['interval'] = currentParams.interval
        }
        const { startDate, endDate } = updateTimePeriod(dispatch, location);
        params.startDate = startDate;
        params.endDate = endDate;
        delete params.cardIndexes;
        delete params.page;
        delete params.limit;
        delete params.sort;
        delete params.sortOrder;
        delete params.search;
        history.push({ pathname, search: getEncodedURI(params) });
        setActiveTab(tabName);
        setFilterPopup(false);
        clearStates();
        setSort('');
    }

    const handleSubTabsClick = (tabValue) => {
        setSubTab(tabValue);
        setFilterPopup(false);
        const params = getDecodeURI(location?.search);
        params.tab = tabValue;
        delete params.cardIndexes;
        delete params.page;
        delete params.limit;
        delete params.sort;
        delete params.sortOrder;
        delete params.search;
        history.push({ pathname: location.pathname, search: getEncodedURI(params) })
        clearStates();
        setSort('');
        setExpand({ ...expand, isLeftChartsExpanded: true, isTableExpanded: analyticsdata?.[activeTab]?.[tabValue]?.hideCharts ? true : false })
    }

    useEffect(() => {
        setPage(1);
        processAnalyticsTopWidgetPayload(dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, activeTab, subTab);
        processAnalyticsLeftChartPayload(dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, activeTab, subTab);
        processAnalyticsRightChartPayload(dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, selectedBin, activeTab, subTab);
        processAnalyticsTablePayload(dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, 1, limit, sort, sortOrder, activeTab, subTab, tableSearchValue);
    }, [selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, activeTab, subTab]);

    useEffect(() => {
        processAnalyticsRightChartPayload(dispatch, analyticsData, selectedOu, vessels, sites, newSummaryStartDate, newSummaryEndDate, newSummaryWanType, selectedBin, activeTab, subTab);
    }, [selectedBin])

    useEffect(() => {
        if (!_.isEmpty(analyticsTopCards)) {
            const selectedIndexes = _q.cardIndexes ? _q.cardIndexes.split(',').map(Number) : [];
            const cardContent = analyticsdata?.[activeTab]?.[subTab]?.topCard;
            const updatedCardContent = updateCardContent(cardContent, analyticsTopCards, selectedIndexes);
            setAnalyticsData(prevData => ({
                ...prevData,
                [activeTab]: {
                    ...prevData?.[activeTab],
                    [subTab]: {
                        ...prevData?.[activeTab]?.[subTab],
                        topCard: updatedCardContent
                    }
                }
            }));
            // getAnalyticsTopCards = {};
        }
    }, [analyticsTopCards, _q.cardIndexes]);

    useEffect(() => {
        if (_.isEmpty(analyticsLeftChart)) {
            setLeftChartData([]);
            return;
        }
        if (!_.isEmpty(analyticsLeftChart)) {
            const leftChartKeys = analyticsData?.[activeTab]?.[subTab]?.leftChart?.leftChartKeys;

            if (!Array.isArray(analyticsLeftChart) || !leftChartKeys) return;

            const transformedData = analyticsLeftChart
                ?.filter((item) => item[leftChartKeys.name]?.trim() !== "")
                ?.map((item) => ({
                    title: leftChartKeys.title,
                    name: item[leftChartKeys.name],
                    y: leftChartKeys['yAxis'].unit == 'GB' ? Number(readableBytesAsGB(item[leftChartKeys['y']], false)) : item[leftChartKeys['y']],
                    z: item[leftChartKeys.z],
                    yAxisLabel: leftChartKeys['yAxis'].label,
                    yAxisUnit: leftChartKeys['yAxis'].unit,
                })
                );
            setLeftChartData(transformedData);
            // dispatch({ type: GET_ANALYTICS_BAR_CHART, payload: {} })
        }
    }, [analyticsLeftChart]);

    useEffect(() => {
        if (_.isEmpty(analyticsRightChart)) {
            setRightChartData([]);
            return;
        }

        const data = analyticsRightChart?.[0];
        const rightChartKeys = analyticsData?.[activeTab]?.[subTab]?.rightChart?.rightChartKeys;
        const rightChartConfig = analyticsData?.[activeTab]?.[subTab]?.namedQueries?.rightChart?.[0];

        const seriesKey = rightChartConfig?.series;
        const groupByKey = rightChartConfig?.groupBy;
        const yAxisLabel = rightChartKeys?.yAxis?.label;
        const yAxisUnit = rightChartKeys?.yAxis?.unit;
        const title = rightChartKeys?.title;

        if (!Array.isArray(analyticsRightChart) || !rightChartKeys) return;

        // Handling multiple series keys (comma-separated values)
        const seriesKeys = seriesKey?.split(",") || [];
        let series: any = {};

        seriesKeys.forEach((key) => {
            if (data?.[key]?.series?.[groupByKey] && Array.isArray(data[key].series[groupByKey])) {
                series[key] = data[key].series[groupByKey];
            } else if (data?.[key]?.series) {
                Object.assign(series, Object.entries(data[key].series).reduce((acc, [name, seriesData]) => {
                    acc[name] = Array.isArray(seriesData) ? seriesData : [];
                    return acc;
                }, {}));
            } else {
                series[key] = [];
            }
        });

        if (_.isEmpty(series)) {
            setRightChartData([]);
            return;
        }

        let convertBytes;

        if (yAxisUnit === "GB") {
            const gbValue = Math.pow(1000, 3);
            const isGBCrossed = Object.values(series).some(
                (seriesData) => Array.isArray(seriesData) && seriesData.some((item) => item.y > gbValue)
            );
            convertBytes = isGBCrossed ? readableBytesAsGB : readableBytesAsMB;
        }

        const lineChartData = Object.entries(series).map(([key, data]) => {
            if (yAxisUnit === "GB" && Array.isArray(data)) {
                data.forEach((el, i) => {
                    if (typeof el.y === "number") {
                        data[i].bytes = el.y;
                        data[i].y = Number(convertBytes(el.y, false));
                    }
                });
            }
            return {
                name: key,
                data,
                marker: { symbol: "circle" },
                visible: true,
                yAxisLabel,
                yAxisUnit: yAxisUnit === "GB" ? (convertBytes === readableBytesAsGB ? "GB" : "MB") : yAxisUnit,
                title
            };
        });

        setRightChartData(lineChartData);
    }, [analyticsRightChart]);

    useEffect(() => {
        if(!_.isEmpty(analyticsTable)) {
            const tableConfig = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys;
            const tableConfigColumns = tableConfig?.columns || [];
            const countKey = analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys?.totalCount
    
            let totalCountValue = 0;
            let normalizedTable: any = [];
    
            if (analyticsTable[0]?.[countKey] > 0) {
                totalCountValue = analyticsTable[0][countKey];
                normalizedTable = analyticsTable;
            } else if (analyticsTable[analyticsTable.length - 1]?.[countKey]) {
                totalCountValue = analyticsTable[analyticsTable.length - 1][countKey];
                normalizedTable = [ { totalCount: totalCountValue }, ...analyticsTable.slice(0, -1)];
            }
            let filteredData = normalizedTable.slice(1);
    
            let finalColumns = tableConfigColumns;
    
            if (activeTab === 'threats' && subTab === 'threat_kontrol') {
                filteredData = filteredData.map(row => {
                    let parsed: { class: string; threat_name: string }[] = [];
                    try {
                        parsed = JSON.parse(row.threat_names_and_classes || '[]');
                    } catch {

                    }
                    return {
                        ...row,
                        classes: parsed.map(o => o.class).join(', '),
                        threat_names: parsed.map(o => o.threat_name).join(', ')
                    };
                });

                finalColumns = tableConfigColumns.map(col => {
                    if (col.label === 'Classes') return { ...col, key: 'classes' };
                    if (col.label === 'Threat Names') return { ...col, key: 'threat_names' };
                    return col;
                });
    
                setVisibleColumns(finalColumns.map(col => col.key));
            }

            setTableData({
                title: tableConfig?.title || '',
                headers: tableConfig?.headers || [],
                tableColumnKeys: tableConfig?.tableColumnKeys || [],
                data: filteredData || [],
                totalCount: totalCountValue || 0,
                loading: setAnalyticsTableLoading,
                columns: finalColumns
            });
            dispatch({ type: GET_ANALYTICS_TABLE, payload: {} })
        }
    }, [analyticsTable, activeTab, subTab, setAnalyticsTableLoading]);

    const toggleExpand = (key) => {
        setExpand((prevState) => {
            if (key === "isCardExpanded") {
                return { isCardExpanded: !prevState.isCardExpanded, isLeftChartsExpanded: prevState.isLeftChartsExpanded, isTableExpanded: prevState.isTableExpanded };
            }
            if (key === "isLeftChartsExpanded") {
                return { isCardExpanded: true, isLeftChartsExpanded: !prevState.isLeftChartsExpanded, isTableExpanded: false };
            }
            if (key === "isTableExpanded") {
                return { isCardExpanded: true, isLeftChartsExpanded: false, isTableExpanded: !prevState.isTableExpanded };
            }
            return prevState;
        });
    };

    const clearStates = () => {
        dispatch({ type: GET_ANALYTICS_TOP_CARDS, payload: {} });
        dispatch({ type: GET_ANALYTICS_BAR_CHART, payload: {} });
        dispatch({ type: GET_ANALYTICS_LINE_CHART, payload: {} });
        dispatch({ type: GET_ANALYTICS_TABLE, payload: {} });
    }

    const totalRowCount = analyticsTable?.[0]?.[analyticsData?.[activeTab]?.[subTab]?.table?.tableKeys?.totalCount] || 0;
    const handleFullDownload = async () => {
        const fullLimit = totalRowCount || 10000;
        const fullPage = 1;

        const payload = await processAnalyticsTablePayload(
            dispatch,
            analyticsData,
            selectedOu,
            vessels,
            sites,
            newSummaryStartDate,
            newSummaryEndDate,
            newSummaryWanType,
            fullPage,
            fullLimit,
            sort,
            sortOrder,
            activeTab,
            subTab,
            tableSearchValue,
            true // isDownloadMode
        );
        if (payload?.data && payload?.columns) {
            downloadCSV(payload.data, payload.columns);
        } else {
            console.error("Download failed. No usable data.");
        }
    };


    const handleSortChange = (columnKey: string) => {
        const newSortOrder = sort === columnKey && sortOrder === 'asc' ? 'desc' : 'asc';
        setSort(columnKey);
        setSortOrder(newSortOrder);
        setPage(1);
        processAnalyticsTablePayload(
            dispatch,
            analyticsData,
            selectedOu,
            vessels,
            sites,
            newSummaryStartDate,
            newSummaryEndDate,
            newSummaryWanType,
            1,
            limit,
            columnKey,
            newSortOrder,
            activeTab,
            subTab,
            tableSearchValue
        );
    };

    const chartRef = useRef<HighchartsReact.RefObject>(null);
      
    const handleDownloadCSV = () => {
        const chart = chartRef.current?.chart;
        if (chart) {
            const csvData = ((activeTab == "trends" && subTab == "usage") || (activeTab == "reports" && subTab == "activity") || (activeTab == "captive")) ? generateCustomUsageCSV(chart, analyticsData?.[activeTab]?.[subTab]?.rightChart?.rightChartKeys?.yAxis?.unit ?? "GB") : chart.getCSV();
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'analytics-charts-report.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error('Chart reference is null or not initialized.');
        }
    };

    return (
        <div className="Form Analytics-Main-Container">
            <CommonFilters loading={loading} showWantType={false} showSummaryPeriod={true} />
            <TabsComponent tabs={Object.values(analyticsData['tabs'])} handleChangeTab={doNavigateSIM} activeTab={activeTab} />
            <Grid className="Analytics-Dashboard-Container">
                <Grid container className="analytics-top-filters-container">
                    <Grid container item md={2} lg={2} className="l-shape-container">
                        <Grid item md={2} lg={2} className={filterPopup ? "l-shape upper" : ''}>
                            <Box className="activityReports-Filter" style={{ width: '100%', height: '100%' }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<TuneIcon id="filterIcon" />}
                                    onClick={() => setFilterPopup(prev => !prev)}
                                    id="filterButton"
                                    style={!filterPopup ? { border: '1px solid rgba(36, 76, 132, 1)', height: '32px', marginTop: '8px', minWidth: 'unset' } : {}}
                                >
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item md={10} lg={10} className="other">
                            <Box className="searchbarBox">
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    placeholder="Filter Search"
                                    autoComplete="off"
                                    size="small"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    InputProps={{
                                        className: "searchbarInputs",
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {!searchValue ? (
                                                    <SearchIcon className="searchbarIconsPosition" />
                                                ) : (
                                                    <CloseIcon className="searchbarIconsPosition" />
                                                )}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Grid>
                        {filterPopup && (
                            <AnalyticsFilters
                                activeTab={activeTab}
                                subTab={subTab}
                                chartType={chartType}
                                setChartType={setChartType}
                                isCardExpanded={isCardExpanded}
                                setIsCardExpanded={setIsCardExpanded}
                                isLeftChartsExpanded={isLeftChartsExpanded}
                                setIsLeftChartsExpanded={setIsLeftChartsExpanded}
                                sites={sites}
                                setSites={setSites}
                                rightChartType={lineChartType}
                                setRightChartType={setLineChartType}
                                visibleColumns={visibleColumns}
                                setVisibleColumns={setVisibleColumns}
                                selectedColumns={selectedColumns}
                                setSelectedColumns={setSelectedColumns}
                            />

                        )}
                    </Grid>
                    <Grid className="analytics-sub-tabs-container" item md={9} lg={9}>
                        {analyticsData?.tabs &&
                            Object.values(analyticsData.tabs).map(tab =>
                                tab.tabValue === activeTab &&
                                tab.subTabs?.map(subTabValue => (
                                    <Button
                                        key={subTabValue.tabValue}
                                        className="analytics-sub-tabs"
                                        id={subTabValue.tabValue === subTab ? 'selectedTab-background' : ''}
                                        onClick={() => handleSubTabsClick(subTabValue.tabValue)}
                                    >
                                        {subTabValue.tabName}
                                    </Button>
                                ))
                            )
                        }
                    </Grid>
                    <Grid item md={1} lg={1} className="download-expand-icons-container" pl={0}>
                        <img src={newDownloadButton} alt="download" />
                        <img
                            src={upArrow}
                            alt={expand.isCardExpanded ? "collapse" : "expand"}
                            onClick={() => toggleExpand("isCardExpanded")}
                            style={{ transform: expand.isCardExpanded ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        />
                    </Grid>
                </Grid>
                <Grid className="Analytics-contents">
                    {expand.isCardExpanded &&
                        <>
                            <AnalyticsCardContents analyticsData={analyticsData} activeTab={activeTab} subTab={subTab} />
                        </>
                    }
                    {!analyticsData?.[activeTab]?.[subTab]?.hideCharts && <Grid container spacing={2} className='new-summary-chart-component'>
                        <Grid item xs={12} sm={12} md={12} lg={12} className="analytics-charts">
                            <Grid container spacing={0} className="usage-per-site-pie">
                                <div className="analytics-charts-title-container">
                                    <Grid item md={6} lg={6}>Graphs</Grid>
                                    <Grid item md={6} lg={6} className="analytics-charts-download-expand-icons">
                                        <img src={newDownloadButton} alt="download"  onClick={handleDownloadCSV}/>
                                        <img
                                            src={upArrow}
                                            alt={expand.isLeftChartsExpanded ? "collapse" : "expand"}
                                            onClick={() => toggleExpand("isLeftChartsExpanded")}
                                            style={{ transform: expand.isLeftChartsExpanded ? 'rotate(0deg)' : 'rotate(180deg)' }}
                                        />
                                    </Grid>
                                </div>
                                {expand.isLeftChartsExpanded &&
                                    <Grid container spacing={1}>
                                        <AnalyticsBarChart barChartData={leftChartData} chartType={chartType} setChartType={setChartType} />
                                        <AnalyticsLineChart lineChartData={rightChartData} chartType={lineChartType} setChartType={setLineChartType} selectedBin={selectedBin} setSelectedBin={setSelectedBin} expand={expand} HighchartsInstance={HighchartsInstance} chartRef={chartRef}/>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>}
                    {!analyticsData?.[activeTab]?.[subTab]?.hiseTable && <div className="config-container">
                        <Grid container spacing={0.5} className="reports-login-history trends-usage-table-container">
                            <Grid item xs={12} sm={12} md={12} lg={12} className="search-dropdown-limit-div trends-usage-search-container topbarMarginPaddingReset alignTopbarItemsCenter" height={'45px'}>
                                <Grid item xs={4} sm={4} md={4} lg={4} className="site-details-header usage-site-details-header">{tableData?.title}</Grid>
                                <Grid item xs={8} sm={8} md={8} lg={8} className="usage-table-search-download-div">
                                    <Grid className="usage-search-border-color">
                                        <Box className="searchbarBox">
                                            {
                                                <TextField
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    placeholder="Type something"
                                                    autoComplete="off"
                                                    size="small"
                                                    value={tableSearchValue}
                                                    onChange={(e) => setTableSearchValue(e.target.value)}
                                                    // onChange={handleOnSearchChange}
                                                    // onKeyDown={(event) => searchBoxKeyDown(event)}
                                                    InputLabelProps={{ className: "serachLabel1" }}
                                                    InputProps={{
                                                        className: "searchbarInputs",
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                {!tableSearchValue && (
                                                                    <SearchIcon className="searchbarIconsPosition" />
                                                                )}
                                                                {tableSearchValue && (
                                                                    <CloseIcon
                                                                        className="searchbarIconsPosition"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => setTableSearchValue('')}
                                                                    />
                                                                )}
                                                            </InputAdornment>
                                                        ),

                                                    }}
                                                />


                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item  className="analytics-table-download-expand-icons">
                                        <img
                                            src={newDownloadButton}
                                            alt="download"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleFullDownload}
                                        />

                                        <img
                                            src={upArrow}
                                            alt={expand.isTableExpanded ? "collapse" : "expand"}
                                            onClick={() => toggleExpand("isTableExpanded")}
                                            style={{ transform: expand.isTableExpanded ? 'rotate(0deg)' : 'rotate(180deg)' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {expand.isTableExpanded && <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersConatiner tablePaddingReset">
                                <NetworkTable
                                    data={setAnalyticsTableLoading ? [] : tableData?.data}
                                    columns={tableData?.columns?.filter(col => visibleColumns.includes(col.key))}
                                    visibleColumns={visibleColumns}
                                    onActionClick={(type, key, row) => console.log(type, key, row)}
                                    onHyperlinkClick={(key, value) => console.log(`Clicked ${key}: ${value}`)}
                                    enablePagination
                                    rowsPerPageOptions={[10, 15, 25]}
                                    defaultRowsPerPage={15}
                                    rowsPerPage={limit}
                                    totalRowCount={setAnalyticsTableLoading ? 0 : tableData?.['totalCount']}
                                    externalSearchValue={tableSearchValue}
                                    headingHeight={40}
                                    maxHeight={
                                        analyticsData?.[activeTab]?.[subTab]?.hideCharts && expand.isCardExpanded
                                            ? `calc(100vh - 400px)`
                                            : analyticsData?.[activeTab]?.[subTab]?.hideCharts && !expand.isCardExpanded
                                                ? 'calc(100vh - 315px)'
                                                : !expand.isCardExpanded
                                                    ? `calc(100vh - 362px)`
                                                    : `calc(100vh - 458px)`
                                    }
                                    page={page}

                                    onRowsPerPageChange={(newLimit) => {
                                        setPage(1);
                                        setLimit(newLimit);
                                        processAnalyticsTablePayload(
                                            dispatch,
                                            analyticsData,
                                            selectedOu,
                                            vessels,
                                            sites,
                                            newSummaryStartDate,
                                            newSummaryEndDate,
                                            newSummaryWanType,
                                            1,
                                            newLimit,
                                            sort,
                                            sortOrder,
                                            activeTab,
                                            subTab,
                                            tableSearchValue
                                        );
                                    }}

                                    onPageChange={(newPage, newLimit) => {
                                        setPage(newPage);
                                        setLimit(newLimit);
                                        processAnalyticsTablePayload(
                                            dispatch,
                                            analyticsData,
                                            selectedOu,
                                            vessels,
                                            sites,
                                            newSummaryStartDate,
                                            newSummaryEndDate,
                                            newSummaryWanType,
                                            newPage,
                                            newLimit,
                                            sort,
                                            sortOrder,
                                            activeTab,
                                            subTab,
                                            tableSearchValue
                                        );
                                    }}
                                    onSortChange={handleSortChange}
                                    sortBy={sort}
                                    sortOrder={sortOrder}
                                />


                            </Grid>}
                        </Grid>
                    </div>}
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    sideMenu: state.authReducer.sideMenu,
    getVesselsListing: state.authReducer.getVesselsListing,
    filteredVessels: state.authReducer.filteredVessels,
    selectedOu: state.authReducer.selectedOu,
    newSummaryStartDate: state.authReducer.newSummaryStartDate,
    newSummaryEndDate: state.authReducer.newSummaryEndDate,
    newSummaryWanType: state.authReducer.newSummaryWanType,
    analyticsTopCards: state.authReducer.getAnalyticsTopCards,
    analyticsLeftChart: state.authReducer.getAnalyticsLeftChart,
    analyticsRightChart: state.authReducer.getAnalyticsRightChart,
    analyticsTable: state.authReducer.getAnalyticsTable,
    setAnalyticsTopCardsLoading: state.authReducer.setAnalyticsTopCardsLoading,
    setAnalyticsBarChartLoading: state.authReducer.setAnalyticsBarChartLoading,
    setAnalyticsLineChartLoading: state.authReducer.setAnalyticsLineChartLoading,
    setAnalyticsTableLoading: state.authReducer.setAnalyticsTableLoading,
});

export default withRouter(
    connect(mapStateToProps, { updatePermission })(AnalyticsDashboard)
);